import { PushDeviceStateNotice } from './PushDeviceStateNotice';
const meta = {
    title: 'Features/Settings/Technicians/PushDeviceStateNotice',
    component: PushDeviceStateNotice,
    parameters: { layout: 'padded' }
};
export default meta;
export const Registered = { args: { state: 'registered' } };
export const NoDevice = { args: { state: 'none' } };
export const TenantDisabled = { args: { state: 'tenant_disabled' } };
export const TierDisabled = { args: { state: 'tier_disabled' } };
/**
 * The state this panel exists for: the platform is healthy and it is our own
 * credentials that are wrong, which is a config change rather than an outage.
 */
export const ApiKeyRejected = {
    args: { state: 'unauthorized', platformError: '401 unauthenticated: unknown or inactive API key' }
};
export const ReadFailed = {
    args: { state: 'read_failed', platformError: '500 unavailable: boom' }
};
export const PlatformUnreachable = {
    args: { state: 'unavailable', platformError: 'timed out: RestClient::Exceptions::OpenTimeout' }
};
